import { render, staticRenderFns } from "./stores-pagination.vue?vue&type=template&id=27e1bf12&scoped=true&"
import script from "./stores-pagination.vue?vue&type=script&lang=js&"
export * from "./stores-pagination.vue?vue&type=script&lang=js&"
import style0 from "./stores-pagination.vue?vue&type=style&index=0&id=27e1bf12&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27e1bf12",
  null
  
)

export default component.exports